import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { CarouselV3Context } from '../../context/CarouselV3Context.js';
import { useRoot } from './hooks/useRoot.js';

var _excluded = ["children"];
var Root = /*#__PURE__*/React.memo(function (props) {
  var children = props.children,
    rest = _objectWithoutProperties(props, _excluded);
  var _useRoot = useRoot(rest),
    contextValue = _useRoot.contextValue,
    rootProps = _useRoot.rootProps;
  return /*#__PURE__*/React.createElement(CarouselV3Context.Provider, {
    value: contextValue
  }, /*#__PURE__*/React.createElement("div", rootProps, children));
});
Root.displayName = 'CarouselV3.Root';

export { Root };
//# sourceMappingURL=Root.js.map
